if (!customElements.get("lookbook-card")) {
	customElements.define(
		"lookbook-card",
		class LookbookCard extends ModalComponent {
			constructor() {
				super();

				this.card = this.closest(".lbcard");

				const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
				mql.onchange = () => {
					this.removeAttribute("open");
					document.body.classList.remove(this.classes.show);
				};
			}

			get isLockingNeeded() {
				return FoxTheme.config.mqlMobile;
			}

			get requiresBodyAppended() {
				return FoxTheme.config.mqlMobile;
			}

			connectedCallback() {
				super.connectedCallback();

				/* START --- Northern Shopper Custom */
				if (!this._nsAddAllBound) {
					this._nsAddAllBound = true;
					this.addEventListener("click", this.handleAddAll.bind(this));
				}
				/* END -- Northern Shopper Custom */
			}

			prepareToShow() {
				super.prepareToShow();

				this.card.classList.add("is-open");

				/* START --- Northern Shopper Custom */
				if (window.NorthernShopper && NorthernShopper.CardQty) {
					NorthernShopper.CardQty.updateAllCards();
				}
				/* END -- Northern Shopper Custom */
			}

			handleAfterHide() {
				super.handleAfterHide();

				this.card.classList.remove("is-open");
			}

			/* START --- Northern Shopper Custom */
			handleAddAll(event) {
				const button = event.target.closest("[data-ns-lookbook-add-all]");
				if (!button || !this.contains(button)) return;

				event.preventDefault();
				event.stopPropagation();

				this.addAllButton = button;
				if (button.disabled || button.getAttribute("aria-disabled") === "true") return;

				const items = this.collectAddAllItems();
				if (!items.length) return;

				this.lastClickedElement = event.currentTarget;

				if (document.body.classList.contains("cart-template") || FoxTheme.settings.cartType != "drawer") {
					FoxTheme.utils.postLink(FoxTheme.routes.cart_add_url, { parameters: { items } });
					return;
				}

				this.showAddAllError();
				this.toggleAddAllLoading(true);

				let sectionsToBundle = [];
				document.documentElement.dispatchEvent(new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));

				const body = JSON.stringify({
					items,
					sections: sectionsToBundle,
					sections_url: window.location.pathname,
				});

				fetch(`${FoxTheme.routes.cart_add_url}`, { ...FoxTheme.utils.fetchConfig("javascript"), ...{ body } })
					.then((response) => response.json())
					.then(async (parsedState) => {
						if (parsedState.status) {
							this.showAddAllError(parsedState.description);
							return;
						}

						const cartJson = await (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })).json();
						cartJson["sections"] = parsedState["sections"];

						FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
						document.dispatchEvent(new CustomEvent("product-ajax:added", { detail: { product: parsedState } }));

						this.hide();
						const cartDrawer = document.querySelector("cart-drawer");
						cartDrawer && cartDrawer.show(this.lastClickedElement);
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.toggleAddAllLoading(false);
					});
			}

			collectAddAllItems() {
				const items = [];
				this.querySelectorAll("[data-ns-card-qty]").forEach((card) => {
					if (card.dataset.available === "false") return;
					const id = parseInt(card.dataset.variantId, 10);
					if (!id) return;
					const min = parseInt(card.dataset.qtyMin, 10) || 1;
					items.push({ id, quantity: min });
				});
				return items;
			}

			showAddAllError(errorMessage = false) {
				const el = this.querySelector(".lbcard__popup-footer .product-form__error-message");
				if (el) {
					el.hidden = !errorMessage;
					if (errorMessage) el.textContent = errorMessage;
				} else if (errorMessage) {
					alert(errorMessage);
				}
			}

			toggleAddAllLoading(status) {
				if (!this.addAllButton) return;
				this.addAllButton.classList.toggle("btn--loading", status);
				if (status) {
					this.addAllButton.setAttribute("disabled", true);
					this.addAllButton.setAttribute("aria-disabled", "true");
				} else {
					this.addAllButton.removeAttribute("disabled");
					this.addAllButton.removeAttribute("aria-disabled");
				}
			}
			/* END -- Northern Shopper Custom */
		},
	);
}

if (!customElements.get("lookbook-card-wrapper")) {
	customElements.define(
		"lookbook-card-wrapper",
		class LookbookCardWrapper extends HTMLElement {
			constructor() {
				super();
			}

			get video() {
				return this.querySelector("video-element");
			}

			connectedCallback() {
				if (!this.video) return;

				this.addEventListener("mouseleave", this.handleMouseInteraction.bind(this, "leave"));
				this.addEventListener("mouseenter", this.handleMouseInteraction.bind(this, "enter"));
			}

			disconnectedCallback() {
				this.removeEventListener("mouseleave");
				this.removeEventListener("mouseenter");
			}

			handleMouseInteraction(type, event) {
				if (type === "enter") {
					this.classList.add("is-hovering");
					this.video.play();
				} else {
					this.classList.remove("is-hovering");
					this.video.pause();
				}
			}
		},
	);
}
